import { AirlineListItemResponse } from "../../../../common/api/admin-api/GetAirlineListResponse";

export interface AirlineListItem {
    id: string;
    name: string;
    code: string;
    buzzId?: string;
    shreqId?: string;
    updatedDate: string;
}

export const mapToAirlineListItem = (item: AirlineListItemResponse): AirlineListItem => {
    return {
        id: item.id,
        name: item.name,
        code: item.code,
        buzzId: item.buzzId,
        shreqId: item.shreqId,
        updatedDate: item.audit.updatedDate
    };
};
